export default "__VITE_ASSET__Fv_EviUm__"